import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_still_valid_independent_certification_standard_audits'

export const dataPointDefinition = {
  retracedId: 'how_many_still_valid_independent_certification_standard_audits',
  name: 'How many still valid independent certification/standard audits has the facility participated in?',
  description:
    '"Independent certifications/standard audits" refers to SOCIAL/LABOR audits that are performed by third-party organizations. These audits typically result in a certification or some form of official audit report. ',
  meta: {
    slcpMeta: {
      key: 'fp-oc-5',
      number: 'FP-CER-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-oc-5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27920,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
